import { computed, inject, Injectable, resource, signal } from '@angular/core';
import { NotificationTemplate } from '../models/notification-template';
import { NotificationRepository } from '../repositories/notification.repository';

@Injectable()
export class NotificationService {
  #notificationRepository = inject(NotificationRepository);

  //* PRIVATE API *//
  readonly #notificationTemplatesResource = resource({
    params: () => this.#orderId(),
    loader: async ({ params }) => {
      const orderId = params;
      if (!orderId) {
        return null;
      }
      const t = await this.#notificationRepository.retrieve(orderId);
      this.#notificationTemplates.set(t);
      return t;
    },
  });

  readonly #notificationTemplates = signal<NotificationTemplate[]>([]);
  readonly #orderId = signal<number | null>(null);

  //* PUBLIC API *//
  readonly notificationTemplateLoading = this.#notificationTemplatesResource.isLoading();

  readonly notificationTemplates = computed(() => {
    return this.#notificationTemplates();
  });

  sendNotification(id: number, template: object): Promise<void> {
    return this.#notificationRepository.sendNotification(id, template);
  }

  loadNotificationTemplates(orderId: number) {
    this.#orderId.set(orderId);
  }
}
